// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: var(--card);
  border-radius: 18px;
  width: 95%;
  max-width: 800px;
  box-shadow: var(--shadow);
}

.modal-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: var(--muted);
}

.modal-body {
  padding: 1rem 1.25rem;
}

.modal-input {
  width: 100%;
  padding: 0.5rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 0.95rem;
}

.modal-label {
  font-weight: 600;
  color: var(--text);
}

.modal-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.5rem;
}

.modal-checkboxes label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: var(--text);
}

.modal-footer {
  padding: 0.75rem 1.25rem;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.btn {
  border: none;
  border-radius: 12px;
  padding: 0.45rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
}

.btn-primary {
  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);
  color: #fff;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: default;
}

.btn-secondary {
  background: #f1f5f9;
  color: var(--text);
}

.acl-list {
  list-style: none;
  margin: 0.5rem 0 1rem 0;
  padding: 0;
}

.acl-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.25rem 0;
}

.acl-webid {
  flex: 1 1;
  word-break: break-all;
}

.acl-perms {
  font-size: 0.8rem;
  color: var(--muted);
}

.acl-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--danger, #c00);
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-box {\n  background: var(--card);\n  border-radius: 18px;\n  width: 95%;\n  max-width: 800px;\n  box-shadow: var(--shadow);\n}\n\n.modal-header {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: var(--muted);\n}\n\n.modal-body {\n  padding: 1rem 1.25rem;\n}\n\n.modal-input {\n  width: 100%;\n  padding: 0.5rem 0.6rem;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  font-size: 0.95rem;\n}\n\n.modal-label {\n  font-weight: 600;\n  color: var(--text);\n}\n\n.modal-checkboxes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-top: 0.5rem;\n}\n\n.modal-checkboxes label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--text);\n}\n\n.modal-footer {\n  padding: 0.75rem 1.25rem;\n  border-top: 1px solid var(--border);\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.btn {\n  border: none;\n  border-radius: 12px;\n  padding: 0.45rem 1rem;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.btn-primary {\n  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);\n  color: #fff;\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.btn-secondary {\n  background: #f1f5f9;\n  color: var(--text);\n}\n\n.acl-list {\n  list-style: none;\n  margin: 0.5rem 0 1rem 0;\n  padding: 0;\n}\n\n.acl-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.25rem 0;\n}\n\n.acl-webid {\n  flex: 1;\n  word-break: break-all;\n}\n\n.acl-perms {\n  font-size: 0.8rem;\n  color: var(--muted);\n}\n\n.acl-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--danger, #c00);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
